module.exports = __webpack_public_path__ + "static/media/sidemenu_restaurant.2f71eba0.svg";